import React from 'react';
import '../css/Projects.css';
import ProjectList from './ProjectList';

const Projects = ({info}) => {
    return (
      <React.Fragment>
        <div className="projects">
          <h1>| My Projects</h1>
          <div className="project-list">
          <ProjectList info={info} />
          </div>
        </div>
      </React.Fragment>
    )
}

export default Projects;
